@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Alternar Usuário</div>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda">Empresa</th>
                <th class="tabela_borda">Usuário</th>
                <th class="tabela_borda">E-mail</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let vendedor of vendedores; templateCacheSize: 0;">
                <td class="text-center tabela_acao">
                  <i class="fa fa-refresh btn_tabela_acao" placement="right" ngbTooltip="Alternar" (click)="alternar(vendedor)"></i>
                </td>
                <td class="tabela_borda">{{ vendedor.nm_empresa }}</td>
                <td class="tabela_borda">{{ vendedor.fullname }}</td>
                <td class="tabela_borda">{{ vendedor.username }}</td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}
